<template>
  <div class="table-scroll">
    <table class="drivers-table">
      <thead>
        <tr>
          <th scope="col">Chauffeur</th>
          <th scope="col">Badges associés</th>
          <th scope="col">Statut</th>
          <th scope="col">Dernière activité</th>
          <th v-if="canManage" scope="col" class="actions-heading">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="driver in drivers" :key="driver.id" :data-driver-id="String(driver.id)" :class="{ selected: String(selectedId) === String(driver.id) }">
          <td>
            <div class="identity">
              <div class="avatar" aria-hidden="true">{{ initials(driver) }}</div>
              <div class="identity-text">
                <router-link class="driver-detail-link" :to="{ name: 'driver-details', params: { driverId: driver.id } }">{{ displayName(driver) }}</router-link>
                <small>Chauffeur #{{ driver.id }} · <router-link class="view-detail" :to="{ name: 'driver-details', params: { driverId: driver.id } }">Voir la fiche ↗</router-link></small>
              </div>
            </div>
          </td>
          <td class="badges-cell">
            <span v-if="!driver.badges || !driver.badges.length" class="no-badges">Aucun badge</span>
            <div v-else class="badges-stack">
              <span v-for="badge in driver.badges" :key="badge.id" class="badge-chip">
                <strong>{{ badge.ref || 'Sans référence' }}</strong>
                <span> · Slot {{ badge.slot != null ? badge.slot : '—' }}</span>
              </span>
            </div>
          </td>
          <td><span class="status" :class="driver.status === 'ACTIVE' ? 'active' : 'inactive'"><span class="dot"></span>{{ driver.status === 'ACTIVE' ? 'Actif' : 'Inactif' }}</span></td>
          <td class="date-cell">{{ formatLastActivity(driver) }}</td>
          <td v-if="canManage" class="action-cell"><button type="button" @click="$emit('edit', driver)">Modifier <span aria-hidden="true">→</span></button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DriverList',
  props: {
    drivers: { type: Array, required: true },
    canManage: { type: Boolean, default: false },
    selectedId: { type: [String, Number], default: null }
  },
  emits: ['edit'],
  methods: {
    displayName(driver) { return [driver.firstName, driver.lastName].filter(Boolean).join(' ') || 'Sans nom'; },
    initials(driver) { return [driver.firstName, driver.lastName].filter(Boolean).map(s => String(s).charAt(0)).join('').slice(0, 2).toLocaleUpperCase('fr') || '—'; },
    formatLastActivity(driver) {
      if (!driver.lastActivity) return driver.displayLastActivity || 'Aucune activité';
      const date = new Date(driver.lastActivity);
      if (Number.isNaN(date.getTime())) return driver.displayLastActivity || 'Aucune activité';
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).format(date);
    }
  }
};
</script>

<style scoped>
.table-scroll { width: 100%; overflow-x: auto; }
.drivers-table { width: 100%; border-collapse: collapse; text-align: left; }
th { background: #fbfcfe; color: #7c8799; font-size: 11px; text-transform: uppercase; letter-spacing: .08em; padding: 15px 25px; white-space: nowrap; font-weight: 800; }
td { border-top: 1px solid #edf0f5; padding: 17px 25px; font-size: 13px; }
tr:hover td { background: #f9fbfe; }
tr.selected td { background: #f2f7ff; }
.identity { display: flex; align-items: center; gap: 12px; min-width: 180px; }
.avatar { background: #eaf0fa; color: #2a558d; border-radius: 12px; width: 41px; height: 41px; display: grid; place-items: center; font-weight: 800; font-size: 12px; flex: none; }
.identity-text { display: flex; flex-direction: column; gap: 3px; }
.driver-detail-link { color: #202e44; font-weight: 750; text-decoration: none; }
.driver-detail-link:hover,.view-detail:hover { color: #1b4f95; text-decoration: underline; }
.driver-detail-link:focus-visible,.view-detail:focus-visible { outline: 2px solid #93b5e3; outline-offset: 2px; border-radius: 3px; }
.view-detail { color: #55759e; text-decoration: none; font-weight: 700; }
.identity-text small { color: #94a0b0; font-size: 11px; }
/* Les étiquettes restent visibles sans masquer les badges au-delà d'un seuil. */
.badges-cell { min-width: 220px; max-width: 460px; }
.badges-stack { display: flex; flex-wrap: wrap; gap: 6px; }
.badge-chip { display: inline-block; max-width: 100%; border: 1px solid #dfe7f2; background: #f3f7fd; border-radius: 7px; padding: 5px 8px; color: #53647c; font-size: 11px; line-height: 1.45; overflow-wrap: anywhere; }
.badge-chip strong { color: #2b537f; font-weight: 750; }
.no-badges { color: #9ba6b5; font-size: 12px; }
.status { display: inline-flex; align-items: center; gap: 7px; border-radius: 99px; padding: 6px 10px; font-size: 11px; font-weight: 750; white-space: nowrap; }
.active { color: #17794b; background: #eaf7f0; }
.inactive { color: #677488; background: #eef1f5; }
.dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.date-cell { color: #65728a; white-space: nowrap; }
.action-cell { text-align: right; }
.action-cell button { color: #1f569b; background: none; border: none; font-weight: 750; cursor: pointer; padding: 8px; white-space: nowrap; }
.action-cell button:hover { text-decoration: underline; }
.actions-heading { text-align: right; }
@media (max-width: 620px) { th, td { padding: 14px 13px; } }
</style>
